<template>
  <el-col v-bind="$props"><slot /></el-col>
</template>

<script>
export default {
  name: 'RtCol',
  props: {
    span: {
      type: Number,
      default: 24
    },
    tag: {
      type: String,
      default: 'div'
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  }
  //   render: function(h) {
  //       return h('el-col', {
  //           props: {
  //               span: this.span,
  //               tag: this.tag,
  //               offset: this.offset,
  //               pull: this.pull,
  //               push: this.push,
  //               xs: this.xs,
  //               sm: this.sm,
  //               md: this.md,
  //               lg: this.lg,
  //               xl: this.xl,
  //           }
  //       }, this.$slots.default)
  //   }
};
</script>



// WEBPACK FOOTER //
// rtCol.vue?655a8322